import { Checkbox, FormControlLabel } from '@mui/material';
import { useAdmin } from '../../../context/AdminContextProvider';

const FilterTeacherAction = () => {
  const { adminTeachersDomain } = useAdmin();
  const { filterActive } = adminTeachersDomain.domainData;

  const handleCheckboxChange = (e) => {
    adminTeachersDomain.updateFilterActive(e.target.checked);
  };

  return (
    <FormControlLabel
      className='filter-margin'
      control={
        (
          <Checkbox
            className='vizzle-checkbox'
            checked={filterActive}
            onChange={handleCheckboxChange}
            color='primary'
          />
        )
      }
      label='Active'
    />
  );
};

export default FilterTeacherAction;
